// Indicates if the client supports WebSockets.
export default global.WebSocket !== undefined;
